import { CSSObject, Color, Theme } from '@mui/material';
import { Breakpoint } from '@mui/material/styles';
import React from 'react';

declare module '@mui/material' {
  interface Color {
    xDark: string;
    dark: string;
    midDark: string;
    main: string;
    midLight: string;
    light: string;
    light7: string;
    light85: string;
    xLight: string;
    xxLight: string;
    xxLightForegroundSmall: string;
    xxLightForegroundLarge: string;
  }
}

interface MapIcon {
  background: string;
  backgroundHover: string;
  text: string;
}

declare module '@mui/material/styles/createTypography' {
  interface FontStyle {
    fontSizes: {
      [K in Size]: string;
    };
  }

  interface TypographyVariants {
    eventsIcon?: TypographyStyle;
  }
}

declare module '@mui/material/styles/createPalette' {
  interface LinkOptions {
    header: string;
    text: string;
  }

  type Colors = {
    [K in ColorNames]: Color;
  };

  interface Palette extends Colors {
    heading?: string;
    link: LinkOptions;
    breadcrumbs?: { background?: string; border?: string };
    mapIcon: MapIcon;
  }
}

declare module '@mui/material/styles/createTheme' {
  interface Theme {
    appBar: AppBarThemeOpts;
    boxShadow: {
      [K in Shadows]: string;
    };
    containerDefaultSize?: Size;
    containerWidth: {
      [K in Size]: string;
    };
    greyBorder: string;
    navBarFontSize: string;
    semanticColors: {
      [index: string]: string;
    };
    zIndexFormInputButtons: number;
    zIndexHoverBox: number;
    zIndexLoader: number;
    zIndexOverlay: number;
  }
}

export interface AppBarThemeOpts extends React.CSSProperties {
  background: string;
  iconBreakPoint: Breakpoint;
  resolveColor: () => string | undefined;
}

export type LibroTheme = Theme;

export interface IndexablePalette {
  [key: string]: Color;

  [key: number]: Color;
}

export type CSSPropertiesMap = { [key: string]: CSSObject };
export type MaterialStyleMap = {
  [key: string]: { styleOverrides?: CSSPropertiesMap; defaultProps?: any };
};

export enum Margin {
  'Small' = 2.7,
  'Medium' = 5.4,
  'Large' = 8.1,
  'XL' = 12,
  'XXL' = 20,
}

export enum Size {
  XSmall = 'xSmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xLarge',
  XXLarge = 'xxLarge',
}

export enum Shadows {
  Transparent = 'transparent',
  Base = 'base',
  Intense = 'intense',
  Inside = 'inside',
  Crazy = 'crazy',
}

enum ColorNames {
  Blue = 'blue',
  Green = 'green',
  Red = 'red',
  Transparent = 'transparent',
  Orange = 'orange',
}

export enum BreakPoints {
  XSmall = 'xs',
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
}
